<template>
    <div :class="{ filter: true, 'open-filter': isFilterOpen }">
        <div class="filter__body">
            <div class="filter__top top-filter">
                <div class="top-filter__title">Фільтри</div>
                <button class="top-filter__close _icon-close" @click="closeFilter"></button>
            </div>

            <div class="filter__line">
                <ChecboxFilterSpecial title="В наявності" :isChecked="inStock" @change="onInStockChange" />
                <ChecboxFilterSpecial title="Під замовлення" :isChecked="onOrder" @change="onOnOrderChange" />
            </div>

            <div v-for="(item, index) in filters" :key="index" class="accordion-item" :class="{ filter__line: true, filter__line_active: isActiveIndex(index) }">
                <div class="accordion-item__header" @click="toggleAccordion(index)">
                    {{ item.name }}
                </div>
                <transition name="accordion" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave">
                    <div ref="setContents" class="accordion-item__content" :style="getContentStyle(index)">
                        <Chekbox v-for="(content, i) in item.values" :key="i" :title="content.value" :filterId="item.id" :filterValueId="content.id" @change="onCheckboxChange(item.id, content.id, $event)" />
                    </div>
                </transition>
            </div>

            <div class="filter__line">
                <div class="filter__title">Вартість</div>

                <div class="filter__price-blocks">
                    <div class="filter__price-block">
                        від
                        <input type="text" v-model="minPrice" @input="filterNumericInput" />
                    </div>
                    <div class="filter__price-block">
                        до
                        <input type="text" v-model="maxPrice" @input="filterNumericInput" />
                    </div>
                </div>
                <div class="filter__price-labels">
                    <span class="filter__price-label" @click="setMaxPrice(600)">до 600 ₴</span>
                    <span class="filter__price-label" @click="setMaxPrice(700)">до 700 ₴</span>
                    <span class="filter__price-label max" @click="setMaxPrice(800)">до 800 ₴</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch } from "vue";
import { useFetch } from "#imports";
import { Chekbox, ChecboxFilterSpecial } from "#components";

const props = defineProps({
    isFilterOpen: Boolean,
    closeFilter: Function,
    categoryId: Number,
});

const config = useRuntimeConfig();
const apiUrl = config.public.apiUrl;

const emit = defineEmits(["filterChange", "inStockChange", "availableForOrderChange", "priceChange"]);

const activeIndices = ref([]);
const filters = ref([]);
const minPrice = ref(310);
const maxPrice = ref(3000);
const inStock = ref(false);
const onOrder = ref(false);

const contents = ref([]);

const setContents = (el) => {
    if (!el) return;
    // опционально очищать и наполнять снова
    contents.value.push(el);
};

watch(filters, () => {
    contents.value = [];
});

const toggleAccordion = (index) => {
    const isActive = isActiveIndex(index);
    if (isActive) {
        activeIndices.value = activeIndices.value.filter((i) => i !== index);
    } else {
        activeIndices.value.push(index);
    }
    updateActiveElementsHeight();
};

const isActiveIndex = (index) => {
    return activeIndices.value.includes(index);
};

const getContentStyle = (index) => {
    const isActive = isActiveIndex(index);
    return {
        maxHeight: isActive ? "none" : "0",
    };
};

const updateActiveElementsHeight = () => {
    activeIndices.value.forEach((index) => {
        const contentEl = contents.value[index];
        if (contentEl) {
            contentEl.style.maxHeight = contentEl.scrollHeight + "px";
        }
    });
};

const setMaxPrice = (price) => {
    maxPrice.value = price;
    emitPriceChange();
};

const filterNumericInput = (event) => {
    const input = event.target;
    input.value = input.value.replace(/\D/g, "");
    emitPriceChange();
};

const emitPriceChange = () => {
    emit("priceChange", { minPrice: minPrice.value, maxPrice: maxPrice.value });
};

const getFilters = async () => {
    const { data } = await $fetch(`${apiUrl}filters`, {
        params: {
            categoryId: props.categoryId,
        },
    });

    filters.value = data;
    if (filters.value) {
        sortValues();
    }
};

const onCheckboxChange = (filterId, filterValueId, isChecked) => {
    const filter = {
        id: filterId,
        value: filterValueId,
        checked: isChecked,
    };
    emit("filterChange", filter);
};

const sortValues = () => {
    filters.value.forEach((item) => {
        item.values.sort((a, b) => {
            let aValue = 0;
            if (a && a.value) {
                const matchA = a.value.match(/\d+\.?\d*/);
                if (matchA) {
                    aValue = parseFloat(matchA[0]);
                }
            }
            const matchB = b.value.match(/\d+\.?\d*/);
            const bValue = matchB ? parseFloat(matchB[0]) : 0;
            return aValue - bValue;
        });
    });
};

const onInStockChange = (isChecked) => {
    inStock.value = isChecked ? 1 : 0;
    emit("inStockChange", inStock.value);
};

const onOnOrderChange = (isChecked) => {
    onOrder.value = isChecked ? 1 : 0;
    emit("availableForOrderChange", onOrder.value);
};

onMounted(() => {
    getFilters();
});

watch(
    () => props.categoryId,
    () => {
        getFilters();
    },
    { immediate: true }
);

watch(minPrice, (newVal) => {
    emitPriceChange();
});

watch(maxPrice, (newVal) => {
    emitPriceChange();
});
</script>

<style></style>
